import * as React from 'react';
import { Context, useContext } from 'react';

import { UseSelectedEmployeeIdStateOutput } from '~/hooks/employee';

export type SelectedEmployeeContextProps = UseSelectedEmployeeIdStateOutput;

export const defaultSelectedEmployeeContextProps: SelectedEmployeeContextProps =
  {
    selectedEmployeeId: -1,
    setSelectedEmployeeId: (_employeeId: number) => {},
    isSelectedEmployeeLoggedInUser: false,
    refreshSelectedEmployeeId: () => {},
    selectedEmployeeDetails: {
      isLoading: false,
      isDataInSync: false,
      isInMyUnits: false,
      hasManagerRelationshipType: () => {
        return false;
      },
    },
    isLoading: false,
  };

export const SelectedEmployeeContext: Context<SelectedEmployeeContextProps> =
  React.createContext(defaultSelectedEmployeeContextProps);

export const useSelectedEmployeeContext = (): SelectedEmployeeContextProps => {
  return useContext<SelectedEmployeeContextProps>(SelectedEmployeeContext);
};
